"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The Teilnehmer model module.
 * @module model/Teilnehmer
 * @version 0.0.1
 */
class Teilnehmer {
  /**
   * Constructs a new <code>Teilnehmer</code>.
   * @alias module:model/Teilnehmer
   * @param nutzerId {String} 
   * @param fortbildungId {Number} 
   * @param id {Number} 
   */
  constructor(nutzerId, fortbildungId, id) {
    Teilnehmer.initialize(this, nutzerId, fortbildungId, id);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, nutzerId, fortbildungId, id) {
    obj['nutzer_id'] = nutzerId;
    obj['fortbildung_id'] = fortbildungId;
    obj['id'] = id;
  }

  /**
   * Constructs a <code>Teilnehmer</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Teilnehmer} obj Optional instance to populate.
   * @return {module:model/Teilnehmer} The populated <code>Teilnehmer</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Teilnehmer();
      if (data.hasOwnProperty('nutzer_id')) {
        obj['nutzer_id'] = _ApiClient.default.convertToType(data['nutzer_id'], 'String');
      }
      if (data.hasOwnProperty('fortbildung_id')) {
        obj['fortbildung_id'] = _ApiClient.default.convertToType(data['fortbildung_id'], 'Number');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>Teilnehmer</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Teilnehmer</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of Teilnehmer.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['nutzer_id'] && !(typeof data['nutzer_id'] === 'string' || data['nutzer_id'] instanceof String)) {
      throw new Error("Expected the field `nutzer_id` to be a primitive type in the JSON string but got " + data['nutzer_id']);
    }
    return true;
  }
}
Teilnehmer.RequiredProperties = ["nutzer_id", "fortbildung_id", "id"];

/**
 * @member {String} nutzer_id
 */
Teilnehmer.prototype['nutzer_id'] = undefined;

/**
 * @member {Number} fortbildung_id
 */
Teilnehmer.prototype['fortbildung_id'] = undefined;

/**
 * @member {Number} id
 */
Teilnehmer.prototype['id'] = undefined;
var _default = exports.default = Teilnehmer;